import { PartnerCardsAdapter as PartnerCards } from "./PartnerCards";

export { PartnerCards };
